import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { GitHub, LinkedIn, Email, ArrowUpward } from '@mui/icons-material';

const FooterWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.default,
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: '48px 0 32px',
}));

const SocialLink = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  width: 36,
  height: 36,
  '&:hover': {
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.primary,
    backgroundColor: 'transparent',
  },
}));

const Mono = styled(Typography)(({ theme }) => ({
  fontFamily: '"JetBrains Mono", ui-monospace, monospace',
  fontSize: '0.8125rem',
  color: theme.palette.text.secondary,
}));

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <FooterWrapper>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 3,
            mb: 4,
          }}
        >
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <SocialLink
              href="https://github.com/DMasilva"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <GitHub fontSize="small" />
            </SocialLink>
            <SocialLink
              href="https://www.linkedin.com/in/david-owuor-082750201/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedIn fontSize="small" />
            </SocialLink>
            <SocialLink
              href="mailto:david.owuor@ndsu.edu"
              aria-label="Email"
            >
              <Email fontSize="small" />
            </SocialLink>
          </Box>

          <SocialLink onClick={scrollToTop} aria-label="Back to top">
            <ArrowUpward fontSize="small" />
          </SocialLink>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            gap: 1,
            pt: 3,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Mono>© {new Date().getFullYear()} David Onyango Owuor</Mono>
          <Mono>Built with React · Hosted on the open web</Mono>
        </Box>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
